import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form";
import { InwardAccepted, InwardEdit } from "../../utils/apis/Inward/Inward";
import { Context } from "../../utils/context";
import Select from "react-select";
import { banckStatus, kycStatus } from "../../utils/apis/Investores/Investores";
import Col from "react-bootstrap/Col";

import Row from "react-bootstrap/Row";
import { formatDate } from "../../utils/common";
import { error } from "jquery";
import Spinner from "react-bootstrap/Spinner";
const BankDetails = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setError,
    setValue,
    control,
    reset,
  } = useForm();

  const options = [
    { value: "Accepted", label: "Accepted" },
    { value: "Rejected", label: "Rejected" },
  ];

  const [reasonShow, setReasonShow] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const { IMG_URL } = useContext(Context);
  const [loader, setLoader] = useState(false);
  // console.log(props.kycID, "kycID kycID");

  const onSubmit = async (d) => {
    setLoader(true);
    const data = {
      verify_status: d?.verify_status?.value,
      remark: d?.remark,
      id: props.bankdata?.id,
    };

    const res = await banckStatus(data);

    if (res.success) {
      props.getData(props?.kycID?.id);
      setReasonShow(false);
      props.onHide();
    } else {
      setError("api", { message: res?.message });
    }
    setLoader(false);

    // getData();
    // Proceed with your logic here
  };

  // console.log(errors);

  useEffect(() => {
    reset();

    if (props.detailType === "KYC") {
      if (props.kycID?.kyc_detail?.verify_status === "Rejected") {
        setReasonShow(true);
        setValue("remark", props.kycID?.kyc_detail?.remark);
      } else {
        setReasonShow(false);
        setValue("remark", "");
      }

      setValue("verify_status", {
        value: props.kycID?.kyc_detail?.verify_status,
        label: props.kycID?.kyc_detail?.verify_status,
      });
    } else {
      if (props.kycID?.kyc_detail?.bank_status === "Rejected") {
        setReasonShow(true);
        setValue("remark", props.kycID?.kyc_detail?.remark);
      } else {
        setReasonShow(false);
        setValue("remark", "");
      }

      setValue("verify_status", {
        value: props.kycID?.kyc_detail?.bank_status,
        label: props.kycID?.kyc_detail?.bank_status,
      });
    }
  }, [props.show]);

  console.log(
    props?.bankdata?.bank_status == "Unverified",
    "props?.bankdata?.bank_status props?.bankdata?.bank_status",
  );

  return (
    <>
      <Modal
        {...props}
        size="xl"
        className="Payment_Screenshotmodal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.detailType === "KYC" ? "KYC Verify" : "Bank Verify"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col
              xxl={8}
              xl={8}
              lg={8}
              style={{ borderRight: "1px solid #000" }}
            >
              <Row>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>Registered Date :</b>{" "}
                    {props?.kycID?.createdAt
                      ? formatDate(props?.kycID?.createdAt)
                      : ""}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>Investor Name :</b> {props?.kycID?.f_name}{" "}
                    {props?.kycID?.l_name}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>Service No. :</b> {props?.kycID?.contact_no}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>State :</b> {props?.kycID?.users_detail?.state?.name}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>District :</b> {props?.kycID?.users_detail?.city?.name}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>Age :</b> {props?.kycID?.users_detail?.age}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>Gender :</b> {props?.kycID?.users_detail?.gender}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>Bank Name :</b> {props?.bankdata?.bank_name}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>Holder Name :</b> {props?.bankdata?.holder_name}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>Ac No. :</b> {props?.bankdata?.ac_no}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <b>IFSC Code :</b> {props?.bankdata?.ifsc_code}
                  </div>
                </Col>
              </Row>
              <div className="mt-5">
                <div className="d-flex mt-5">
                  <p>
                    <b>PassBook/Cheque:</b>
                  </p>
                  <img
                    src={IMG_URL + props?.bankdata?.passbook}
                    width={100}
                    onClick={() =>
                      setPreviewImage(IMG_URL + props?.bankdata?.passbook)
                    }
                  />
                </div>
              </div>
            </Col>

            <Col xxl={4} xl={4} lg={4}>
              <div className="mt-5">
                <img src={previewImage} style={{ width: "100%" }} />
              </div>
            </Col>
          </Row>

          <div className="mt-4">
            {reasonShow && (
              <>
                <input
                  type="text"
                  id="firstName"
                  {...register("remark", {
                    // required: "Reason is required"
                  })}
                  className="form-control"
                  placeholder="Reason for Rejection"
                />
                <span className="text-danger">{errors?.remark?.message}</span>
              </>
            )}
          </div>
          {(props?.bankdata?.bank_status === "Unverified" ||
            props?.bankdata?.bank_status == null) && (
            <div className="d-flex mt-5">
              <Controller
                name="verify_status"
                control={control}
                rules={{
                  required: "Status is required",
                }}
                render={({ field }) => (
                  <Select
                    className="select-drop"
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor: errors.verify_status
                          ? "red"
                          : baseStyles.borderColor,
                      }),
                    }}
                    classNamePrefix="custom-select-class"
                    placeholder="Select Status"
                    {...field}
                    options={options}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      setValue("verify_status", selectedOption);

                      setReasonShow(selectedOption?.value === "Rejected");
                    }}
                  />
                )}
              />

              {loader ? (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : (
                <button
                  type="button"
                  className="btn btn-success ms-3"
                  onClick={handleSubmit(onSubmit)}
                >
                  Submit
                </button>
              )}
            </div>
          )}

          <div className="d-flex mt-5">
            <span className="text text-danger">{errors?.api?.message}</span>
          </div>

          {/* <div className="">
            <div className="d-flex">
              <p>
                <b>Uploaded Photo:</b>
              </p>
              <img src={IMG_URL + props?.kycID?.kyc_detail?.image} width={100} />

              <p>
                <b>Aadhar Photo Front:</b>
              </p>
              <img src={IMG_URL + props?.kycID?.kyc_detail?.aadhar_photo} width={100} />

              <p>
                <b>Aadhar Photo Back:</b>
              </p>
              <img src={IMG_URL + props?.kycID?.kyc_detail?.aadhar_photo_back} width={100} />
            </div>
            <div className="d-flex mt-5">
              <p>
                <b>Pan Card:</b>
              </p>
              <img src={IMG_URL + props?.kycID?.kyc_detail?.pan_card} width={100} />
              <p>
                <b>PassBook/Cheque:</b>
              </p>
              <img src={IMG_URL + props?.kycID?.kyc_detail?.passbook} width={100} />
            </div>

            <div className="mt-4">


              {reasonShow && (
                <>
                  <input
                    type="text"
                    id="firstName"
                    {...register("remark", {
                      required: "Reason is required"
                    })}
                    className="form-control"

                    placeholder="Reason for Rejection"
                  />
                  <span className="text-danger">{errors?.remark?.message}</span>
                </>
              )}
            </div>

            <div className="d-flex mt-5">
              <Controller
                name="verify_status"
                {...register("verify_status", {
                  required: "Status is required"
                })}
                control={control}
                render={({ field }) => (
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor: errors.verify_status
                          ? "red"
                          : baseStyles,
                      }),
                    }}
                    classNamePrefix="custom-select-class"
                    placeholder="Select Status"
                    {...field}
                    options={options}
                    onChange={(selectedOption) => {
                      setValue('verify_status', selectedOption);
                      if (selectedOption?.value === "Rejected") {
                        setReasonShow(true);
                      } else {
                        setReasonShow(false);
                        setError('remark',"");
                        setValue('remark', "");
                      }
                    }}
                  />
                )}
              />
              <button
                type="button"
                className="btn btn-success ms-3"
                onClick={handleSubmit(onSubmit)}
              >
                Submit
              </button>
            </div>
          </div> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BankDetails;

//mutiple

// import React, { useContext, useEffect, useState } from "react";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import { Controller, useForm } from "react-hook-form";
// import { InwardAccepted, InwardEdit } from "../../utils/apis/Inward/Inward";
// import { Context } from "../../utils/context";
// import Select from "react-select";
// import {
//   banckStatus,
//   getBankDetail,
//   kycStatus,
// } from "../../utils/apis/Investores/Investores";
// import Col from "react-bootstrap/Col";

// import Row from "react-bootstrap/Row";
// import { formatDate } from "../../utils/common";
// import { error } from "jquery";
// import ModalSave from "./ModalSave";

// const BankDetails = (props) => {
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     getValues,
//     setError,
//     setValue,
//     control,
//     reset,
//   } = useForm();

//   const options = [
//     { value: "Accepted", label: "Accepted" },
//     { value: "Rejected", label: "Rejected" },
//   ];

//   const optionskyc = [
//     { value: "Accepted", label: "Accepted" },
//     { value: "Rejected", label: "Rejected" },
//     { value: "AIVerification", label: "AI Verification" },
//     { value: "ManualReview", label: "Manual Review" },
//   ];

//   const [reasonShow, setReasonShow] = useState(false);
//   const [previewImage, setPreviewImage] = useState("");
//   const [selectedBank, setSelectedBank] = useState(null);
//   const { IMG_URL } = useContext(Context);
//   const [showModal, setShowModal] = useState({
//     code: 0,
//     message: "",
//   });
// const [data, setData] = useState("");
// const getData = async (id) => {
//   const res = await getBankDetail(id);

//   if (res.success) {
//     setData(res?.data);
//   } else {
//   }
// };
// useEffect(() => {
//   getData(props.kycID?.id);
// }, [props.kycID]);

//   const verifyBank = async (bank) => {
//     const bankId = bank?.id;

//     const verifyStatus = getValues(`bank_verify_status_${bankId}`)?.value;

//     const remark = getValues(`bank_remark_${bankId}`) || "";

//     if (!verifyStatus) {
//       setError(`bank_verify_status_${bankId}`, {
//         type: "required",
//         message: "Status is required",
//       });
//       return;
//     }

//     if (verifyStatus === "Rejected" && !remark.trim()) {
//       setError(`bank_remark_${bankId}`, {
//         type: "required",
//         message: "Reason is required",
//       });
//       return;
//     }

//     const data = {
//       verify_status: verifyStatus,
//       remark: remark,
//       id: bankId,
//       type: "BANK",
//     };

//     const res = await banckStatus(data);

//     if (res.success) {
//       getData(props.kycID?.id);
//       setReasonShow(null);
//       // optional
//       setSelectedBank(null);
//       setShowModal({
//         code: res.code,
//         message: res.message,
//       });
//       setTimeout(() => {
//         setShowModal({ code: 0, message: "" });
//         // props.handleClose();
//       }, 1000);

//       // If you don't want modal to close, DON'T call this
//       // props.onHide();
//     } else {
//       setError("api", {
//         message: res?.message,
//       });
//     }
//   };

//   // console.log(errors);

//   useEffect(() => {
//     reset();

//     if (props.detailType === "KYC") {
//       if (props.kycID?.kyc_detail?.verify_status === "Rejected") {
//         setReasonShow(true);
//         setValue("remark", props.kycID?.kyc_detail?.remark);
//       } else {
//         setReasonShow(false);
//         setValue("remark", "");
//       }

//       setValue("verify_status", {
//         value: props.kycID?.kyc_detail?.verify_status,
//         label: props.kycID?.kyc_detail?.verify_status,
//       });
//     } else {
//       if (props.kycID?.kyc_detail?.bank_status === "Rejected") {
//         setReasonShow(true);
//         setValue("remark", props.kycID?.kyc_detail?.remark);
//       } else {
//         setReasonShow(false);
//         setValue("remark", "");
//       }

//       setValue("verify_status", {
//         value: props.kycID?.kyc_detail?.bank_status,
//         label: props.kycID?.kyc_detail?.bank_status,
//       });
//     }
//   }, [props.show]);

//   return (
//     <>
//       <Modal
//         {...props}
//         size="xl"
//         className="Payment_Screenshotmodal"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title id="contained-modal-title-vcenter">
//             Bank Verify
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Row>
//             <Col
//               xxl={8}
//               xl={8}
//               lg={8}
//               style={{ borderRight: "1px solid #000" }}
//             >
//               <Row>
//                 <Col md={6}>
//                   <div className="main-form-section mt-3">
//                     <b>Registered Date :</b>{" "}
//                     {data?.createdAt ? formatDate(data?.createdAt) : ""}
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="main-form-section mt-3">
//                     <b>Investor Name :</b> {data?.f_name} {data?.l_name}
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="main-form-section mt-3">
//                     <b>Service No. :</b> {data?.contact_no}
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="main-form-section mt-3">
//                     <b>State :</b> {data?.users_detail?.state?.name}
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="main-form-section mt-3">
//                     <b>District :</b> {data?.users_detail?.city?.name}
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="main-form-section mt-3">
//                     <b>Age :</b> {data?.users_detail?.age}
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <div className="main-form-section mt-3">
//                     <b>Gender :</b> {data?.users_detail?.gender}
//                   </div>
//                 </Col>
//                 <Col md={6}>
//                   <p>
//                     <b>Uploaded Photo:</b>
//                   </p>
//                   <img
//                     src={IMG_URL + data?.kyc_detail?.image}
//                     width={100}
//                     onClick={() =>
//                       setPreviewImage(IMG_URL + data?.kyc_detail?.image)
//                     }
//                   />
//                 </Col>
//               </Row>
//               <Row>
//                 {data?.bank_accounts?.length > 0 ? (
//                   data.bank_accounts.map((bank, index) => (
//                     <React.Fragment key={bank?.id || index}>
//                       <Col md={12}>
//                         <div className="mt-4 mb-2">
//                           <h5>Bank Account {index + 1}</h5>
//                         </div>
//                       </Col>

//                       <Col md={6}>
//                         <div className="main-form-section mt-3">
//                           <b>Holder Name :</b> {bank?.holder_name || "-"}
//                         </div>
//                       </Col>

//                       <Col md={6}>
//                         <div className="main-form-section mt-3">
//                           <b>Ac No. :</b> {bank?.ac_no || "-"}
//                         </div>
//                       </Col>

//                       <Col md={6}>
//                         <div className="main-form-section mt-3">
//                           <b>IFSC Code :</b> {bank?.ifsc_code || "-"}
//                         </div>
//                       </Col>

//                       <Col md={6}>
//                         <div className="main-form-section mt-3">
//                           <b>Verify Status :</b>{" "}
//                           <span
//                             className={
//                               bank?.bank_status === "Accepted"
//                                 ? "text-success"
//                                 : bank?.bank_status === "Rejected"
//                                   ? "text-danger"
//                                   : "text-warning"
//                             }
//                           >
//                             {bank?.bank_status || "Unverified"}
//                           </span>
//                         </div>
//                       </Col>

//                       <Col md={12}>
//                         <div className="main-form-section mt-3">
//                           <b>PassBook/Cheque :</b>{" "}
//                           {bank?.passbook ? (
//                             <img
//                               src={IMG_URL + bank.passbook}
//                               width={100}
//                               height={70}
//                               style={{
//                                 cursor: "pointer",
//                                 objectFit: "cover",
//                                 marginLeft: "10px",
//                               }}
//                               alt="Passbook"
//                               onClick={() =>
//                                 setPreviewImage(IMG_URL + bank.passbook)
//                               }
//                             />
//                           ) : (
//                             "-"
//                           )}
//                         </div>
//                       </Col>

//                       {bank?.bank_status === "Unverified" && (
//                         <Col md={12}>
//                           <div className="d-flex align-items-start gap-3 mt-3">
//                             {/* Status */}
//                             <div style={{ width: "350px" }}>
//                               <Controller
//                                 name={`bank_verify_status_${bank.id}`}
//                                 control={control}
//                                 defaultValue={
//                                   bank?.verify_status
//                                     ? {
//                                         value: bank.verify_status,
//                                         label: bank.verify_status,
//                                       }
//                                     : null
//                                 }
//                                 rules={{
//                                   required: "Status is required",
//                                 }}
//                                 render={({ field }) => (
//                                   <Select
//                                     {...field}
//                                     classNamePrefix="custom-select-class"
//                                     placeholder="Select Status"
//                                     options={
//                                       props.detailType === "KYC"
//                                         ? optionskyc
//                                         : options
//                                     }
//                                     styles={{
//                                       control: (baseStyles) => ({
//                                         ...baseStyles,
//                                         minHeight: "45px",
//                                         borderColor: errors?.[
//                                           `bank_verify_status_${bank.id}`
//                                         ]
//                                           ? "red"
//                                           : baseStyles.borderColor,
//                                       }),
//                                     }}
//                                     onChange={(selectedOption) => {
//                                       field.onChange(selectedOption);

//                                       setReasonShow(
//                                         selectedOption?.value === "Rejected"
//                                           ? bank.id
//                                           : null,
//                                       );
//                                     }}
//                                   />
//                                 )}
//                               />

//                               {errors?.[`bank_verify_status_${bank.id}`] && (
//                                 <span className="text-danger">
//                                   {
//                                     errors[`bank_verify_status_${bank.id}`]
//                                       .message
//                                   }
//                                 </span>
//                               )}
//                             </div>

//                             {/* Verify */}
//                             <button
//                               type="button"
//                               className="btn btn-primary"
//                               style={{ height: "45px" }}
//                               onClick={() => verifyBank(bank)}
//                             >
//                               Verify
//                             </button>

//                             {/* Reason */}
//                             {reasonShow === bank.id && (
//                               <div style={{ width: "350px" }}>
//                                 <input
//                                   type="text"
//                                   className="form-control"
//                                   placeholder="Reason for Rejection"
//                                   {...register(`bank_remark_${bank.id}`, {
//                                     required: "Reason is required",
//                                   })}
//                                 />

//                                 {errors?.[`bank_remark_${bank.id}`] && (
//                                   <span className="text-danger">
//                                     {errors[`bank_remark_${bank.id}`].message}
//                                   </span>
//                                 )}
//                               </div>
//                             )}
//                           </div>
//                         </Col>
//                       )}

//                       <Col md={12}>
//                         <hr className="mt-4" />
//                       </Col>
//                     </React.Fragment>
//                   ))
//                 ) : (
//                   <Col md={12}>
//                     <div className="alert alert-warning mt-4 text-center">
//                       No bank detail uploaded.
//                     </div>
//                   </Col>
//                 )}
//               </Row>
//             </Col>

//             <Col xxl={4} xl={4} lg={4}>
//               <div className="mt-5">
//                 <img src={previewImage} style={{ width: "100%" }} />
//               </div>
//             </Col>
//           </Row>

//           <div className="d-flex mt-5">
//             <span className="text text-danger">{errors?.api?.message}</span>
//           </div>
//         </Modal.Body>
//         <ModalSave
//           message={showModal.message}
//           showErrorModal={!!showModal.code}
//         />
//       </Modal>
//     </>
//   );
// };

// export default BankDetails;
